// src/components/emailMarketing/EmailPreview.jsx
import React, { useState } from 'react';
import { FaEye, FaTimes } from 'react-icons/fa';

function EmailPreview({ htmlBody, subject, contactName = 'Juan Pérez', marcaName = 'Mi Marca' }) {
    const [showPreview, setShowPreview] = useState(false);

    // Reemplazar placeholders con datos de ejemplo
    const getPreviewContent = () => {
        if (!htmlBody) return '';
        
        return htmlBody
            .replace(/\{\{contact\.name\}\}/g, contactName)
            .replace(/\{\{contact\.email\}\}/g, 'cliente@example.com')
            .replace(/\{\{contact\.firstName\}\}/g, contactName.split(' ')[0])
            .replace(/\{\{contact\.lastName\}\}/g, contactName.split(' ')[1] || '')
            .replace(/\{\{marca\.name\}\}/g, marcaName)
            .replace(/\{\{marca\.email\}\}/g, 'contacto@mimarca.com')
            .replace(/\{\{marca\.phone\}\}/g, '+34 600 000 000')
            .replace(/\{\{unsubscribe\.url\}\}/g, 'https://tuapp.com/email-marketing/unsubscribe/ejemplo-token')
            .replace(/\{\{unsubscribe\.link\}\}/g, 'https://tuapp.com/email-marketing/unsubscribe/ejemplo-token');
    };

    if (!htmlBody) {
        return null;
    }

    return (
        <>
            <button
                type="button"
                onClick={() => setShowPreview(true)}
                className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600 flex items-center mb-4"
            >
                <FaEye className="mr-2" />
                Ver Preview
            </button>

            {showPreview && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col">
                        {/* Header */}
                        <div className="bg-gray-100 px-6 py-4 flex justify-between items-center">
                            <h3 className="text-lg font-semibold">Preview del Email</h3>
                            <button
                                onClick={() => setShowPreview(false)}
                                className="text-gray-500 hover:text-gray-700"
                            >
                                <FaTimes className="text-xl" />
                            </button>
                        </div>

                        {/* Email Preview */}
                        <div className="flex-1 overflow-auto p-6">
                            <div className="mb-4 pb-4 border-b">
                                <p className="text-sm text-gray-600 mb-1">De: {marcaName} &lt;contacto@mimarca.com&gt;</p>
                                <p className="text-sm text-gray-600 mb-1">Para: {contactName} &lt;cliente@example.com&gt;</p>
                                <p className="font-semibold">Asunto: {subject || '(Sin asunto)'}</p>
                            </div>
                            <div 
                                className="email-preview-content"
                                dangerouslySetInnerHTML={{ __html: getPreviewContent() }}
                                style={{
                                    fontFamily: 'Arial, sans-serif',
                                    lineHeight: '1.6'
                                }}
                            />
                        </div>

                        {/* Footer */}
                        <div className="bg-gray-100 px-6 py-4 text-sm text-gray-600">
                            <p>Este es un preview con datos de ejemplo. Los placeholders se reemplazarán con datos reales al enviar.</p>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default EmailPreview;

